<script setup lang="ts">

interface Props {
  options: Record<string, string>
  modelValue: string
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])

</script>

<template>
  <div class="border-2 border-brand-primary rounded-full p-2 flex items-center mt-10 cursor-pointer w-max">
    <button 
      v-for="[key, value] in Object.entries(props.options)" 
      @click="emit('update:modelValue', key)" 
      :class="[
        'text-center px-6 h-10 text-xs font-semibold rounded-full grid place-content-center relative overflow-hidden box-border',
        props.modelValue === key && 'border-2 border-brand-primary'
      ]"
    >
      <span v-if="props.modelValue === key" class="bg-brand-gradient absolute inset-0 -z-5 inline-block" />
      <span v-if="props.modelValue === key" class="bg-brand-background opacity-70 absolute inset-0 -z-3 inline-block" />
      {{ value }}
    </button>
  </div>
</template>